interface AppConfig {
  API_URL: string;
  [key: string]: any;
}

let configPromise: Promise<AppConfig> | null = null;

const localDevApiURL = 'https://dev.api.buildyourownups.abb.com/api/';

const loadConfig = async (): Promise<AppConfig> => {
  try {
    const response = await fetch('/config/appConfig.json');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Failed to load external config, using fallback:', error);
    // Fallback configuration
    return {
      API_URL: localDevApiURL
    };
  }
};

export const getConfig = (): Promise<AppConfig> => {
  configPromise ??= loadConfig();
  return configPromise;
};

export const getApiUrl = async (): Promise<string> => {
  const config = await getConfig();
  return config.API_URL;
}; 